// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Withdrawal history — full width on desktop (classic admin table) */
.lp-withdraw-history {
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 768px) {
  .lp-withdraw-history {
    max-width: none;
    margin-left: 0;
    margin-right: 0;
  }
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-history .page-header h4 .text-primary {
  color: #7dd3fc !important;
}

.lp-pending-withdraw .lp-pending-withdraw-filters .form-select {
  min-height: 38px;
  font-size: 0.85rem;
}

@media (max-width: 767px) {
  .lp-pending-withdraw.container-fluid {
    padding-left: 0.65rem;
    padding-right: 0.65rem;
  }

  .lp-pending-withdraw .card-header h5 {
    font-size: 0.95rem;
  }
}

.lp-withdraw-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0.65rem 0.75rem 0.5rem;
  border-bottom: 1px solid #e4e4e7;
  background: rgba(248, 250, 252, 0.85);
}

.lp-withdraw-tab {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.lp-withdraw-tab:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

.lp-withdraw-tab--active {
  background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tabs {
  background: rgba(15, 23, 42, 0.5);
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tab {
  background: #0c0f14;
  border-color: rgba(255, 255, 255, 0.12);
  color: #94a3b8;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tab:hover {
  color: #e2e8f0;
  border-color: rgba(255, 255, 255, 0.2);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tab--active {
  background: linear-gradient(135deg, #0284c7 0%, #4f46e5 100%);
  color: #f8fafc;
}

.lp-withdraw-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: stretch;
  margin-bottom: 0.55rem;
}

.lp-withdraw-filters .form-control,
.lp-withdraw-filters .form-control-sm {
  min-height: 34px !important;
  font-size: 0.8rem !important;
  padding: 0.3rem 0.45rem !important;
}

.lp-withdraw-filters-grow {
  flex: 1 1 120px;
  min-width: 0;
}

/* Mobile: three-line rows */
.lp-withdraw-rows {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-radius: 10px;
  border: 1px solid #e4e4e7;
  overflow: hidden;
  background: #fff;
}

.lp-withdraw-row {
  padding: 0.45rem 0.55rem;
  border-bottom: 1px solid #f1f5f9;
}

.lp-withdraw-row--3line {
  display: flex;
  flex-direction: column;
  gap: 0.32rem;
  padding: 0.55rem 0.65rem;
}

.lp-withdraw-row:last-child {
  border-bottom: none;
}

.lp-withdraw-row__line1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.7rem;
  line-height: 1.25;
}

.lp-withdraw-row__meta {
  color: #64748b;
  font-weight: 500;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.lp-withdraw-row__spacer {
  flex: 1 1;
  min-width: 4px;
}

.lp-withdraw-row__amt {
  font-size: 0.95rem;
  font-weight: 800;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  color: #15803d;
  letter-spacing: -0.02em;
}

.lp-withdraw-row__line2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.55rem;
  font-size: 0.76rem;
  line-height: 1.35;
}

.lp-withdraw-row__line2--pending {
  gap: 0.25rem;
}

.lp-withdraw-row__user {
  font-weight: 600;
  min-width: 0;
}

.lp-withdraw-row__user a {
  font-weight: 600;
  color: #0369a1;
}

.lp-withdraw-row__phone {
  color: #475569;
  font-weight: 500;
  text-decoration: none;
}

.lp-withdraw-row__phone--muted {
  color: #94a3b8;
  font-weight: 400;
}

.lp-withdraw-row__type-pill {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.14rem 0.45rem;
  border-radius: 6px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(14, 165, 233, 0.1));
  color: #4338ca;
  border: 1px solid rgba(99, 102, 241, 0.22);
}

.lp-withdraw-row__line3 {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-top: 0.38rem;
  margin-top: 0.06rem;
  border-top: 1px solid #eef2f7;
}

.lp-withdraw-row__upi-block {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  font-size: 0.72rem;
}

.lp-withdraw-row__upi-label {
  flex-shrink: 0;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.lp-withdraw-row__upi {
  flex: 1 1 auto;
  min-width: 0;
  color: #3f3f46;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lp-withdraw-row__copy {
  flex-shrink: 0;
  border: 1px solid #c7d2fe;
  background: #eef2ff;
  color: #4338ca;
  font-size: 0.62rem;
  font-weight: 700;
  padding: 0.18rem 0.45rem;
  border-radius: 6px;
  cursor: pointer;
  line-height: 1;
}

.lp-withdraw-row__copy:active {
  transform: scale(0.98);
}

.lp-withdraw-row__actions {
  width: 100%;
  min-width: 0;
}

.lp-withdraw-row__actions .lp-wd-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.3rem;
}

.lp-withdraw-row__actions--pending-queue {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}

.lp-withdraw-row__actions .lp-wd-btn {
  padding: 0.22rem 0.48rem;
  font-size: 0.65rem;
}

.lp-withdraw-row__sep {
  opacity: 0.55;
  -webkit-user-select: none;
          user-select: none;
}

.lp-withdraw-row__linkbtn {
  border: none;
  background: none;
  padding: 0;
  font-size: inherit;
  font-weight: 600;
  color: #4f46e5;
  text-decoration: underline;
  cursor: pointer;
}

.lp-withdraw-row__line2 .lp-wd-toolbar {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}

.lp-withdraw-row__line2 .lp-wd-btn {
  padding: 0.2rem 0.45rem;
  font-size: 0.65rem;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-rows {
  background: #0c0f14;
  border-color: rgba(255, 255, 255, 0.08);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__amt {
  color: #4ade80;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__user a {
  color: #7dd3fc;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__upi {
  color: #d4d4d8;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__meta {
  color: #94a3b8;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__line3 {
  border-top-color: rgba(255, 255, 255, 0.08);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__type-pill {
  background: rgba(99, 102, 241, 0.18);
  color: #c4b5fd;
  border-color: rgba(129, 140, 248, 0.35);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__phone {
  color: #cbd5e1;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__copy {
  background: rgba(99, 102, 241, 0.2);
  border-color: rgba(129, 140, 248, 0.4);
  color: #c4b5fd;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__linkbtn {
  color: #a5b4fc;
}

.lp-withdraw-mobile {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.lp-withdraw-card {
  border-radius: 8px;
  padding: 0.5rem 0.6rem;
}

.lp-withdraw-card--slim {
  border-left: 3px solid rgba(34, 197, 94, 0.65);
}

.lp-withdraw-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}

.lp-withdraw-card-top-main {
  min-width: 0;
  flex: 1 1;
}

.lp-withdraw-card-amount {
  flex-shrink: 0;
  font-size: 0.95rem;
  font-weight: 700;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  color: #16a34a;
  line-height: 1.2;
  padding: 0.15rem 0.4rem;
  border-radius: 6px;
  background: rgba(22, 163, 74, 0.1);
}

.lp-withdraw-card-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.4rem;
  margin-bottom: 0.45rem;
}

.lp-withdraw-card-title {
  font-weight: 600;
  font-size: 0.82rem;
  margin-top: 0.2rem;
  line-height: 1.25;
}

.lp-withdraw-card-meta {
  font-size: 0.68rem;
  opacity: 0.88;
}

.lp-withdraw-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.35rem 0.5rem;
  font-size: 0.78rem;
}

.lp-withdraw-card-grid dt {
  margin: 0;
  font-size: 0.58rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.72;
}

.lp-withdraw-card-grid dd {
  margin: 0;
  font-weight: 600;
}

.lp-withdraw-card-actions {
  margin-top: 0.5rem;
  padding-top: 0.45rem;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
}

.lp-withdraw-card-actions .lp-wd-toolbar {
  width: 100%;
}

.lp-withdraw-card-actions .lp-wd-toolbar-actions {
  flex: 1 1 auto;
  justify-content: flex-start;
}

@media (max-width: 767px) {
  .lp-withdraw-card-actions .lp-wd-toolbar-actions {
    width: 100%;
  }

  .lp-withdraw-card-actions .lp-wd-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.2rem);
    min-height: 36px;
  }
}

.lp-withdraw-card-actions .d-flex {
  flex-wrap: wrap;
  gap: 0.3rem;
}

/* Withdraw row actions — Approve / Fail / Check (shared with desktop table) */
.lp-wd-toolbar {
  gap: 0.35rem;
}

.lp-wd-toolbar-badge {
  flex-shrink: 0;
}

.lp-wd-toolbar-actions {
  gap: 0.35rem;
}

.lp-wd-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0.28rem 0.55rem;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.lp-wd-btn:active {
  transform: scale(0.98);
}

.lp-wd-btn--approve {
  background: #ecfdf5;
  border-color: #22c55e;
  color: #166534;
}

.lp-wd-btn--approve:hover {
  background: #d1fae5;
}

.lp-wd-btn--fail {
  background: #fef2f2;
  border-color: #ef4444;
  color: #b91c1c;
}

.lp-wd-btn--fail:hover {
  background: #fee2e2;
}

.lp-wd-btn--sync {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #1d4ed8;
}

.lp-wd-btn--sync:hover {
  background: #dbeafe;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-wd-btn--approve {
  background: rgba(34, 197, 94, 0.15);
  border-color: rgba(74, 222, 128, 0.45);
  color: #86efac;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-wd-btn--fail {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(248, 113, 113, 0.45);
  color: #fca5a5;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-wd-btn--sync {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(96, 165, 250, 0.45);
  color: #93c5fd;
}

.lp-withdraw-pager {
  padding: 0.45rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.lp-withdraw-pager .page-link {
  padding: 0.25rem 0.45rem !important;
  font-size: 0.75rem !important;
}

.lp-withdraw-desktop-wrap {
  max-height: none;
  overflow: visible;
  border-radius: 0;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-amount {
  color: #4ade80;
  background: rgba(74, 222, 128, 0.12);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card {
  background: #0c0f14;
  border: 1px solid rgba(255, 255, 255, 0.06);
  color: #e4e4e7;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card--slim {
  border-left-color: rgba(74, 222, 128, 0.5);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-title a {
  color: #7dd3fc;
}

.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  color: #3f3f46;
}

.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card-title a {
  color: #0284c7;
}

.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card-amount {
  color: #15803d;
  background: rgba(22, 163, 74, 0.12);
}

.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card--slim {
  border-left-color: #22c55e;
}

.admin-app.admin-theme-v2 .lp-withdraw-desktop-table thead th {
  font-size: 0.65rem !important;
  padding: 0.4rem 0.45rem !important;
}

.admin-app.admin-theme-v2 .lp-withdraw-desktop-table tbody td {
  padding: 0.4rem 0.45rem !important;
  font-size: 0.78rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/transaction/WithdrawHistory.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;EAClC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,sFAAsF;EACtF,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB","sourcesContent":["/* Withdrawal history — full width on desktop (classic admin table) */\n.lp-withdraw-history {\n  max-width: 1080px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n@media (min-width: 768px) {\n  .lp-withdraw-history {\n    max-width: none;\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-history .page-header h4 .text-primary {\n  color: #7dd3fc !important;\n}\n\n.lp-pending-withdraw .lp-pending-withdraw-filters .form-select {\n  min-height: 38px;\n  font-size: 0.85rem;\n}\n\n@media (max-width: 767px) {\n  .lp-pending-withdraw.container-fluid {\n    padding-left: 0.65rem;\n    padding-right: 0.65rem;\n  }\n\n  .lp-pending-withdraw .card-header h5 {\n    font-size: 0.95rem;\n  }\n}\n\n.lp-withdraw-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  padding: 0.65rem 0.75rem 0.5rem;\n  border-bottom: 1px solid #e4e4e7;\n  background: rgba(248, 250, 252, 0.85);\n}\n\n.lp-withdraw-tab {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #475569;\n  font-size: 0.78rem;\n  font-weight: 600;\n  padding: 0.35rem 0.85rem;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.lp-withdraw-tab:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.lp-withdraw-tab--active {\n  background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tabs {\n  background: rgba(15, 23, 42, 0.5);\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tab {\n  background: #0c0f14;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #94a3b8;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tab:hover {\n  color: #e2e8f0;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-tab--active {\n  background: linear-gradient(135deg, #0284c7 0%, #4f46e5 100%);\n  color: #f8fafc;\n}\n\n.lp-withdraw-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: stretch;\n  margin-bottom: 0.55rem;\n}\n\n.lp-withdraw-filters .form-control,\n.lp-withdraw-filters .form-control-sm {\n  min-height: 34px !important;\n  font-size: 0.8rem !important;\n  padding: 0.3rem 0.45rem !important;\n}\n\n.lp-withdraw-filters-grow {\n  flex: 1 1 120px;\n  min-width: 0;\n}\n\n/* Mobile: three-line rows */\n.lp-withdraw-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border-radius: 10px;\n  border: 1px solid #e4e4e7;\n  overflow: hidden;\n  background: #fff;\n}\n\n.lp-withdraw-row {\n  padding: 0.45rem 0.55rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.lp-withdraw-row--3line {\n  display: flex;\n  flex-direction: column;\n  gap: 0.32rem;\n  padding: 0.55rem 0.65rem;\n}\n\n.lp-withdraw-row:last-child {\n  border-bottom: none;\n}\n\n.lp-withdraw-row__line1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  font-size: 0.7rem;\n  line-height: 1.25;\n}\n\n.lp-withdraw-row__meta {\n  color: #64748b;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.lp-withdraw-row__spacer {\n  flex: 1;\n  min-width: 4px;\n}\n\n.lp-withdraw-row__amt {\n  font-size: 0.95rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #15803d;\n  letter-spacing: -0.02em;\n}\n\n.lp-withdraw-row__line2 {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.55rem;\n  font-size: 0.76rem;\n  line-height: 1.35;\n}\n\n.lp-withdraw-row__line2--pending {\n  gap: 0.25rem;\n}\n\n.lp-withdraw-row__user {\n  font-weight: 600;\n  min-width: 0;\n}\n\n.lp-withdraw-row__user a {\n  font-weight: 600;\n  color: #0369a1;\n}\n\n.lp-withdraw-row__phone {\n  color: #475569;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.lp-withdraw-row__phone--muted {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.lp-withdraw-row__type-pill {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 0.14rem 0.45rem;\n  border-radius: 6px;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12), rgba(14, 165, 233, 0.1));\n  color: #4338ca;\n  border: 1px solid rgba(99, 102, 241, 0.22);\n}\n\n.lp-withdraw-row__line3 {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding-top: 0.38rem;\n  margin-top: 0.06rem;\n  border-top: 1px solid #eef2f7;\n}\n\n.lp-withdraw-row__upi-block {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n  font-size: 0.72rem;\n}\n\n.lp-withdraw-row__upi-label {\n  flex-shrink: 0;\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n}\n\n.lp-withdraw-row__upi {\n  flex: 1 1 auto;\n  min-width: 0;\n  color: #3f3f46;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lp-withdraw-row__copy {\n  flex-shrink: 0;\n  border: 1px solid #c7d2fe;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 0.62rem;\n  font-weight: 700;\n  padding: 0.18rem 0.45rem;\n  border-radius: 6px;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.lp-withdraw-row__copy:active {\n  transform: scale(0.98);\n}\n\n.lp-withdraw-row__actions {\n  width: 100%;\n  min-width: 0;\n}\n\n.lp-withdraw-row__actions .lp-wd-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.lp-withdraw-row__actions--pending-queue {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.lp-withdraw-row__actions .lp-wd-btn {\n  padding: 0.22rem 0.48rem;\n  font-size: 0.65rem;\n}\n\n.lp-withdraw-row__sep {\n  opacity: 0.55;\n  user-select: none;\n}\n\n.lp-withdraw-row__linkbtn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: inherit;\n  font-weight: 600;\n  color: #4f46e5;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.lp-withdraw-row__line2 .lp-wd-toolbar {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.lp-withdraw-row__line2 .lp-wd-btn {\n  padding: 0.2rem 0.45rem;\n  font-size: 0.65rem;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-rows {\n  background: #0c0f14;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row {\n  border-bottom-color: rgba(255, 255, 255, 0.06);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__amt {\n  color: #4ade80;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__user a {\n  color: #7dd3fc;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__upi {\n  color: #d4d4d8;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__meta {\n  color: #94a3b8;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__line3 {\n  border-top-color: rgba(255, 255, 255, 0.08);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__type-pill {\n  background: rgba(99, 102, 241, 0.18);\n  color: #c4b5fd;\n  border-color: rgba(129, 140, 248, 0.35);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__phone {\n  color: #cbd5e1;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__copy {\n  background: rgba(99, 102, 241, 0.2);\n  border-color: rgba(129, 140, 248, 0.4);\n  color: #c4b5fd;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-row__linkbtn {\n  color: #a5b4fc;\n}\n\n.lp-withdraw-mobile {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.lp-withdraw-card {\n  border-radius: 8px;\n  padding: 0.5rem 0.6rem;\n}\n\n.lp-withdraw-card--slim {\n  border-left: 3px solid rgba(34, 197, 94, 0.65);\n}\n\n.lp-withdraw-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.4rem;\n}\n\n.lp-withdraw-card-top-main {\n  min-width: 0;\n  flex: 1;\n}\n\n.lp-withdraw-card-amount {\n  flex-shrink: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #16a34a;\n  line-height: 1.2;\n  padding: 0.15rem 0.4rem;\n  border-radius: 6px;\n  background: rgba(22, 163, 74, 0.1);\n}\n\n.lp-withdraw-card-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.4rem;\n  margin-bottom: 0.45rem;\n}\n\n.lp-withdraw-card-title {\n  font-weight: 600;\n  font-size: 0.82rem;\n  margin-top: 0.2rem;\n  line-height: 1.25;\n}\n\n.lp-withdraw-card-meta {\n  font-size: 0.68rem;\n  opacity: 0.88;\n}\n\n.lp-withdraw-card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.35rem 0.5rem;\n  font-size: 0.78rem;\n}\n\n.lp-withdraw-card-grid dt {\n  margin: 0;\n  font-size: 0.58rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  opacity: 0.72;\n}\n\n.lp-withdraw-card-grid dd {\n  margin: 0;\n  font-weight: 600;\n}\n\n.lp-withdraw-card-actions {\n  margin-top: 0.5rem;\n  padding-top: 0.45rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.15);\n}\n\n.lp-withdraw-card-actions .lp-wd-toolbar {\n  width: 100%;\n}\n\n.lp-withdraw-card-actions .lp-wd-toolbar-actions {\n  flex: 1 1 auto;\n  justify-content: flex-start;\n}\n\n@media (max-width: 767px) {\n  .lp-withdraw-card-actions .lp-wd-toolbar-actions {\n    width: 100%;\n  }\n\n  .lp-withdraw-card-actions .lp-wd-btn {\n    flex: 1 1 calc(50% - 0.2rem);\n    min-height: 36px;\n  }\n}\n\n.lp-withdraw-card-actions .d-flex {\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n/* Withdraw row actions — Approve / Fail / Check (shared with desktop table) */\n.lp-wd-toolbar {\n  gap: 0.35rem;\n}\n\n.lp-wd-toolbar-badge {\n  flex-shrink: 0;\n}\n\n.lp-wd-toolbar-actions {\n  gap: 0.35rem;\n}\n\n.lp-wd-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 0.28rem 0.55rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\n}\n\n.lp-wd-btn:active {\n  transform: scale(0.98);\n}\n\n.lp-wd-btn--approve {\n  background: #ecfdf5;\n  border-color: #22c55e;\n  color: #166534;\n}\n\n.lp-wd-btn--approve:hover {\n  background: #d1fae5;\n}\n\n.lp-wd-btn--fail {\n  background: #fef2f2;\n  border-color: #ef4444;\n  color: #b91c1c;\n}\n\n.lp-wd-btn--fail:hover {\n  background: #fee2e2;\n}\n\n.lp-wd-btn--sync {\n  background: #eff6ff;\n  border-color: #3b82f6;\n  color: #1d4ed8;\n}\n\n.lp-wd-btn--sync:hover {\n  background: #dbeafe;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-wd-btn--approve {\n  background: rgba(34, 197, 94, 0.15);\n  border-color: rgba(74, 222, 128, 0.45);\n  color: #86efac;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-wd-btn--fail {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(248, 113, 113, 0.45);\n  color: #fca5a5;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-wd-btn--sync {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(96, 165, 250, 0.45);\n  color: #93c5fd;\n}\n\n.lp-withdraw-pager {\n  padding: 0.45rem;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lp-withdraw-pager .page-link {\n  padding: 0.25rem 0.45rem !important;\n  font-size: 0.75rem !important;\n}\n\n.lp-withdraw-desktop-wrap {\n  max-height: none;\n  overflow: visible;\n  border-radius: 0;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-amount {\n  color: #4ade80;\n  background: rgba(74, 222, 128, 0.12);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card {\n  background: #0c0f14;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  color: #e4e4e7;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card--slim {\n  border-left-color: rgba(74, 222, 128, 0.5);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-withdraw-card-title a {\n  color: #7dd3fc;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  color: #3f3f46;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card-title a {\n  color: #0284c7;\n}\n\n.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card-amount {\n  color: #15803d;\n  background: rgba(22, 163, 74, 0.12);\n}\n\n.admin-app.admin-theme-v2.admin-theme-light .lp-withdraw-card--slim {\n  border-left-color: #22c55e;\n}\n\n.admin-app.admin-theme-v2 .lp-withdraw-desktop-table thead th {\n  font-size: 0.65rem !important;\n  padding: 0.4rem 0.45rem !important;\n}\n\n.admin-app.admin-theme-v2 .lp-withdraw-desktop-table tbody td {\n  padding: 0.4rem 0.45rem !important;\n  font-size: 0.78rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
